import React, { memo } from 'react';

import { useSelector } from 'react-redux';
import { string } from 'prop-types';
import cn from 'classnames';

import {
  selectEffectiveChannelState,
  selectIsVariantChannelPanelHydrating,
  selectMasterProduct,
  selectProductIsActionBusy,
} from '../../store/selectors/productSelectors';
import ProductStateTabs from './ProductStateTabs';
import ConnectChannelSection from './ConnectChannelSection';
import ProductInfoSkeleton from './ProductInfoSkeleton';
import styles from './styles.module.scss';

const ProductInfo = ({ productId, variantId }) => {
  const product = useSelector((state) => selectMasterProduct(state, productId));
  const { isMasterView } = useSelector(
    (state) => selectEffectiveChannelState(state, productId, variantId),
  );
  const isVariantChannelPanelHydrating = useSelector(
    (state) => selectIsVariantChannelPanelHydrating(state, productId, variantId),
  );
  const isActionBusy = useSelector((state) => selectProductIsActionBusy(state, productId));

  if (!product._id || product.isLoading || isVariantChannelPanelHydrating) {
    return (
      <div className={cn('InfoPanel', styles.skeletonHost)}>
        <ProductInfoSkeleton />
      </div>
    );
  }

  return (
    <div className={cn('InfoPanel', styles.panel, {
      [styles.disabled]: product.isBusy && !isActionBusy,
      [styles.actionBusy]: isActionBusy,
    })}
    >
      <If condition={isActionBusy}>
        <div className={styles.actionBusyOverlay} data-testid="product-info-action-busy">
          <ProductInfoSkeleton />
        </div>
      </If>
      <If condition={isMasterView}>
        <div data-qa="details-header" className={cn('detailsPanel__header  detailsPanel__btns', styles.header)}>
          <ConnectChannelSection productId={productId} variantId={variantId} />
        </div>
      </If>
      <ProductStateTabs productId={productId} variantId={variantId} />
    </div>
  );
};

ProductInfo.propTypes = {
  productId: string.isRequired,
  variantId: string,
};

ProductInfo.defaultProps = {
  variantId: null,
};

export default memo(ProductInfo);
